<!--
 * @Description: 图片查重列表弹层
 * @Date: 2021-11-08 14:15:47
-->
<template>
  <el-dialog
    center
    title="图片重复关联项目"
    :visible="true"
    :before-close="closeDialog"
    top="7vh"
    width="1500px"
  >
    <base-table :tableColumn="tableColumns" :data="tableData" height="55vh" />
    <base-pagination
      v-model="tablePageQuery"
      :total="tableTotal"
      @input="getTableData"
    />
  </el-dialog>
</template>

<script>
import baseTable from '../../components/Base/baseTable';
import auditRow from '@R/services/audit-row';
import { auditOssStatus } from '@R/api/index';
import { listRepeatPic } from '@/api/ajax';
import basePagination from '@R/components/Base/basePagination';
import baseTableMixin from '@C/Base/baseTableMixin';

const ENUMS = {
  auditStatus: [
    '未提交审核',
    '审核中',
    '审核通过',
    '审核未通过',
    '审核中（重新提交）'
  ],
  auditOssStatus: ['未提交审核', '审核中', '审核通过', '审核未通过'],
  auditGongyeStatus: ['未提交审核', '审核中', '审核通过', '审核未通过']
};
export default {
  name: 'repeatPickureTable',
  mixins: [baseTableMixin],
  components: {
    baseTable,
    basePagination
  },
  props: ['projectId', 'sceneType', 'currentTaskId', 'isOpenedByOther'], // isOpenedByOther 是否其他页面跳入或打开。
  data() {
    return {
      tableData: [],
      tableColumns: [
        {
          prop: 'taskDt',
          label: '提交时间',
          width: '150px'
        },
        {
          prop: 'fullName',
          label: '项目参与人',
          width: '150px'
        },
        {
          // prop: 'repeatImgUrls',
          label: '重复图片',
          width: '500px',
          tooltip: false,
          render: (h, { row }) => {
            const { repeatImgUrls } = row;
            let images = repeatImgUrls.split(',');
            return h(
              'div',
              !!images &&
                images.map(ele => {
                  return h('el-image', {
                    props: {
                      zIndex: 3001,
                      src: ele,
                      previewSrcList: images
                    },
                    style: {
                      width: '100px',
                      height: '100px',
                      'margin-right': '15px'
                    },
                    on: {
                      click: () => {
                        this.handleClickItem();
                      }
                    }
                  });
                })
            );
          }
        },
        {
          label: '服务商状态',
          prop: 'auditStatus',
          formatter: ({ val }) => {
            return ENUMS['auditStatus'][val];
          }
        },
        {
          label: '平台状态',
          prop: 'auditOssStatus',
          formatter: ({ val }) => {
            return ENUMS['auditOssStatus'][val];
          }
        },
        {
          label: '工业状态',
          prop: 'auditGongyeStatus',
          formatter: ({ val }) => {
            return ENUMS['auditGongyeStatus'][val];
          }
        },
        {
          label: '操作',
          width: '200px',
          fixed: 'right',
          hidden: this.isOpenedByOther,
          render: (h, { scope, row }) => {
            return (
              <span>
                <el-button
                  type="text"
                  size="mini"
                  disabled={
                    row.auditStatus == 2 ||
                    row.isItOperable === 0 ||
                    row.isItOperable === 2 // "isItOperable" : 0 ,// 此条数据是否可以操作 通过 不通过，0否1是 如果不能操作，则此数据只能查看，其余操作都不可
                  }
                  onClick={() => {
                    auditRow({
                      ajax: auditOssStatus,
                      params: {
                        auditStatus: 2,
                        taskId: row.repeatTaskId,
                        projectId: this.projectId
                      },
                      auditStatus: 2,
                      getList: this.getTableData
                    }).then(() => {
                      this.$emit('parentRefresh');
                    });
                  }}
                >
                  通过
                </el-button>
                <el-button
                  type="text"
                  size="mini"
                  disabled={
                    row.auditStatus == 3 || row.isItOperable === 0 // "isItOperable" : 0 ,// 此条数据是否可以操作 通过 不通过，0否1是 如果不能操作，则此数据只能查看，其余操作都不可
                  }
                  onClick={() => {
                    auditRow({
                      ajax: auditOssStatus,
                      params: {
                        auditStatus: 3,
                        taskId: row.repeatTaskId,
                        projectId: this.projectId
                      },
                      auditStatus: 3,
                      getList: this.getTableData
                    }).then(() => {
                      this.$emit('parentRefresh');
                    });
                  }}
                >
                  不通过
                </el-button>
              </span>
            );
          }
        }
      ]
    };
  },
  methods: {
    async getTableData() {
      const params = {
        currentTaskId: this.currentTaskId,
        sceneType: this.sceneType,
        projectId: this.projectId
      };
      const result = await listRepeatPic(
        Object.assign(params, this.tablePageQuery)
      );
      const {
        data: { list, total }
      } = result.data;
      this.tableData = list;
      this.tableTotal = total;
    },
    closeDialog() {
      const d = document.getElementsByClassName('el-drawer__wrapper')[0];
      const a = document.getElementsByClassName('el-image-viewer__wrapper');
      if (!a.length && !d) {
        this.$emit('close');
      } else if (d && a.length === 1) {
        this.$emit('close');
      }
    },
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask');
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click();
        });
      });
    }
  },
  watch: {
    tableData: {
      handler(v) {
        const arr = [];
        v.forEach(item => {
          const imgListLength = item.repeatImgUrls.split(',').length;
          arr.push(imgListLength);
        });
        //找出图片最多的一项用最多的宽度来作为列宽
        const maxLength = arr.sort()[arr.length - 1];
        this.tableColumns[2].width = maxLength * 130 + 'px';
      }
    },
    deep: true
  },
  created() {
    this.getTableData();
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-image {
  display: inline-block;
}
</style>
